import React from 'react';
import { Link } from 'react-router-dom';
import { useGetNeighborhoodsQuery } from '../../../redux/slices/neighborhoodSlice';

import styles from '../../../../stylesheets/public/components/List.module.postcss';

function NeighborhoodList({ vehicleType }) {
  const { data = {}, isFetching, isSuccess } = useGetNeighborhoodsQuery();
  const neighborhoods = data.neighborhoods || [];

  if (!neighborhoods || (neighborhoods && neighborhoods.length < 1)) {
    return null;
  }

  return (
    <div>
      <h3>Browse by neighborhood</h3>
      <div className={styles.List_items}>
        {neighborhoods.map((neighborhood) => (
          <div
            className={styles.List_item}
            key={neighborhood.id}
          >
            <Link to={`/search?open_today=true&location=${neighborhood.id}`}>
              {neighborhood.name} food {vehicleType.toLowerCase()}s
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default NeighborhoodList;
